<div class="mt-16">
  <div class="detalhes-pedido__box-section p-4 h-100">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-3">
        <div>
          <img src="assets/icones/vermelho/ok_icon.svg" alt="" width="80" />
        </div>

        <div>
          <h2>Arquivo importado com sucesso!</h2>
          <span>Confira abaixo um resumo das informações importadas, ou se desejar, pode fechar esta tela.</span>
        </div>
      </div>
      <button mat-stroked-button (click)="eventNewImport.emit()">Fechar</button>
    </div>
  </div>
  <!-- Resumo do CSV -->
  <spe-titulo-sessao
    *ngIf="detalhamento?.qtdEmpresa || detalhamento?.qtdRegiao || detalhamento?.qtdFuncionario"
    titulo="Resumo do CSV"
    icone="/assets/icones/cinza/olho-aberto.svg"
  >
  </spe-titulo-sessao>

  <div
    *ngIf="detalhamento?.qtdEmpresa !== 0 || detalhamento?.qtdRegiao !== 0 || detalhamento?.qtdFuncionario !== 0"
    class="row g-4"
  >
    <div class="col-12 col-lg-4 col-xl-3">
      <div class="detalhes-pedido__box-section pt-64 h-100">
        <h2>{{ detalhamento?.qtdEmpresa || 0 }}</h2>
        Empresa{{ detalhamento?.qtdEmpresa && detalhamento?.qtdEmpresa! > 1 ? 's' : '' }}
      </div>
    </div>

    <div class="col-12 col-lg-4 col-xl-3">
      <div class="detalhes-pedido__box-section pt-64 h-100">
        <h2>{{ detalhamento?.qtdRegiao || 0 }}</h2>
        Regi{{ detalhamento?.qtdRegiao && detalhamento?.qtdRegiao! > 1 ? 'ões' : 'ão' }}
      </div>
    </div>

    <div class="col-12 col-lg-4 col-xl-3">
      <div class="detalhes-pedido__box-section pt-64 h-100">
        <h2>{{ detalhamento?.qtdFuncionario || 0 }}</h2>
        Funcionário{{ detalhamento?.qtdFuncionario && detalhamento?.qtdFuncionario! > 1 ? 's' : '' }}
      </div>
    </div>
  </div>

  <!-- Produtos -->
  <spe-titulo-sessao *ngIf="detalhamento?.produtos?.length" titulo="Produtos" icone="/assets/icones/cinza/box.svg">
  </spe-titulo-sessao>
  <div class="row g-4">
    <div class="col-12 col-lg-4 col-xl-3" *ngFor="let produto of detalhamento?.produtos || []">
      <div class="detalhes-pedido__box-section pt-32 pb-32 h-100">
        <div class="d-flex align-items-center h-100">
          <img
            [src]="commonService.getBenefitImgSrc(produto.descricao)"
            class="me-4"
            [alt]="'Imagem cartão ' + produto.descricao"
            height="104"
          />
          <div>
            <b>{{ produto.descricao }}</b> <br />

            {{ commonService.showValue(produto.valorTotal) }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Total -->
  <spe-titulo-sessao titulo="Total" icone="/assets/icones/cinza/coins.svg"> </spe-titulo-sessao>
  <div class="detalhes-pedido__box-section p-4 h-100">
    <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between">
      <div
        class="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-5 mb-4 mb-lg-0 mx-0 mx-md-auto mx-lg-0"
      >
        <div>
          <h2 class="text-nowrap">{{ commonService.showValue(detalhamento?.valorTotalIPB || 0) }}</h2>
          <span class="font-size-14 text-nowrap">Total CSV</span>
        </div>
        <div>
          <h2 class="text-nowrap">{{ commonService.showValue(detalhamento?.valorTotalVTO || 0) }}</h2>
          <span class="font-size-14 text-nowrap">Total Sem Parar</span>
        </div>
        <div>
          <h2 class="color-brand-principal text-nowrap">{{ commonService.showValue(detalhamento?.diferenca || 0) }}</h2>
          <span class="font-size-14 text-nowrap">Diferença</span>
        </div>
      </div>
      <div class="w-100">
        <button class="ms-auto d-block" mat-flat-button (click)="eventDetalhamento.emit()">
          Detalhes da importação
        </button>
      </div>
    </div>
  </div>
</div>
